import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class RangeButtonService {
    public subscriber: Subject<number> = new Subject<number>();
}